import { type_user } from "../UserManagementHelper";
import MultiCheckbox from "../../../material/multiCheckbox/MultiCheckbox";

const Role = ({ disableRole, role, onInputChange }) => {

  return (
    <div className="rounded-[6px] border-[#E2E2E4] border p-[9px_16px] mb-[10px] w-full">
      <h1 className="text-[18px] mb-[10px]">ประเภทของผู้ใช้งาน</h1>
      <MultiCheckbox
        value={role.role}
        setValue={(value) => onInputChange("role", value)}
        list={type_user}
        fix={["ADMIN"]}
        disableRole={disableRole}
      />
    </div>
  );
};

export default Role;
